import {blueColor} from '../../cmsMainStyle'

const uploadFileFormStyle = theme => ({
	column: {
		display: "flex",
		// justifyContent: "center",
		alignItems: "center",
		textAlign: 'center',
		// fontWeight: 'bold',
		padding: 2,
		backgroundColor: blueColor[3],
	},

	contentGroup: {
		display: "flex",
		alignItems: "center",
		textAlign: 'center',

	},

	content: {
		display: "flex",
		alignItems: "center",
		textAlign: 'center',
		padding: theme.spacing(1),
	},

	fileDataPaper: {
		width: "100%",
		margin: theme.spacing(1),
		background: "rgba(230, 245, 255, 0.4)"
	},



	infoArea: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 100),
		overflowY: "auto",
		overflowX: "hidden",
	},

	viewerArea: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 90),
		overflowY: "auto",
		overflowX: "hidden",

		paddingTop: theme.spacing(1),
		paddingLeft: theme.spacing(1)
	},

	datePickerField: {
		width: '100%',
	},

})


export {uploadFileFormStyle}